<template>
    <div>
        <v-card>
            <v-data-table v-model="selectedRecords" show-select :headers="tableHeaders" :items="recordsList"
                :loading="loading" class="elevation-1" :server-items-length="totalRows" :options.sync="options"
                disable-sort item-key="id" :footer-props="{ showFirstLastPage: true }">
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>{{ $t('records') }}</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="getRecordsList">
                                    <v-icon large>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t('refresh') }}
                            </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="deleteRecordDialog = true">
                                    <v-icon medium>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t("delete") }}
                            </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="red" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="deleteAllRecordDialog = true">
                                    <v-icon large>mdi-delete-sweep</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t("delete_all") }}
                            </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="showFilter = !showFilter">
                                    <v-icon medium>mdi-filter</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t("filter") }}
                            </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="indexRecordingsDialog = true"
                                    v-show="hasPermission('webinar_plus_room_add')">
                                    <v-icon large>mdi-file-restore-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t('index_recordings') }}
                            </span>
                        </v-tooltip>
                    </v-toolbar>
                   
                        <v-row dense>
                            <v-col cols="12" lg="3" md="4" >
                                {{ $t('max_recording_time')}} : {{ recordsStatistics?.max_recording_time }}
                            </v-col>
                            <v-col cols="12" lg="3" md="4">
                                {{ $t('recording_total_time')}} : {{ recordsStatistics?.recording_total_time }}
                            </v-col>
                            <v-col cols="12" lg="3" md="4">
                                {{ $t('recording_remaining_time')}} : {{ recordsStatistics?.recording_remaining_time }}
                            </v-col>
                        </v-row>   
                   
                    <v-expand-transition>
                        <v-sheet class="ma-3 pa-3" v-show="showFilter" dense>
                            <v-row dense flex>
                                <v-col cols="12" lg="2" md="4">
                                    <v-text-field v-model="nameFilter" @keydown.enter="getRecordsList()"
                                        :label="$t('name')" outlined dense hide-details>
                                    </v-text-field>
                                </v-col> 
                                <v-col cols="12" lg="2" md="4">
                                    <v-text-field v-model="recordIdFilter" @keydown.enter="getRecordsList()"
                                        :label="$t('recordId')" outlined dense hide-details>
                                    </v-text-field>
                                </v-col>  
                                <v-col cols="12" lg="2" md="4">
                                    <v-text-field v-model="meetingIdFilter" @keydown.enter="getRecordsList()"
                                        :label="$t('meetingId')" outlined dense hide-details>
                                    </v-text-field>
                                </v-col> 
                                <v-col cols="12" lg="2" md="4">
                                       <v-text-field id="custom_start_time" v-model="startTimeFilter"
                                    @keydown.enter="getRecordsList()" :label="$t('start_time')" outlined dense hide-details
                                    append-icon="mdi-calendar" @click:append="startTimeDatePicker = true" clearable>
                                </v-text-field>
                                <date-picker v-model="startTimeFilter" element="custom_start_time" color="#00acc1"
                                    editable @close="startTimeDatePicker = false" :show="startTimeDatePicker" range>
                                </date-picker>
                                </v-col>
                                <v-col cols="12" lg="1" md="4">
                                    <v-btn rounded @click="getRecordsList" color="primary">
                                        <v-icon> mdi-filter </v-icon>
                                        {{ $t("filter") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-sheet>
                    </v-expand-transition>
                </template>
                <template v-slot:[`item.playback`]="{ item }">
                    <a :href="getLink(item)" target="_blank">
                        {{ getLink(item) }}
                    </a>
                    <v-divider class="my-2"></v-divider>
                    <a :href="getLink(item.formats, 'video')" target="_blank">
                        {{ getLink(item, 'video') }}
                    </a>
                </template>
            </v-data-table>
        </v-card>
        <AskDialog :visible="indexRecordingsDialog" yes no @yesClick="indexRecordings"
            @noClick="indexRecordingsDialog = false" :text="$t('index_recordings_ask')"></AskDialog>
        <AskDialog :visible="deleteRecordDialog" yes no :loading="deleteLoading" @yesClick="deleteRecord"
            @noClick="deleteRecordDialog = false" :text="deleteRecordDialogText"></AskDialog>
        <AskDialog :visible="deleteAllRecordDialog" yes no :loading="deleteLoading" @yesClick="deleteAllRecord"
            @noClick="deleteAllRecordDialog = false" :text="deleteAllRecordDialogText"></AskDialog>
    </div>
</template>
<script>
import axios from 'axios';
import permissions from '../mixins/permissions';
export default {
    name: "WebinarRecords",
    mixins: [permissions],
    props: ["data"],
    data() {
        return {
            tableHeaders: [
                { text: this.$t("name"), value: "name" },
                { text: this.$t("view_playback"), value: "playback" },
                { text: this.$t("duration"), value: "playbackLength" },
                { text: this.$t("start_time"), value: "start_time" },
                { text: this.$t("end_time"), value: "end_time" },
                { text: this.$t("meeting_name"), value: "room.name" },
            ],
            recordsList: [],
            selectedRecords: [],
            deleteRecordDialog: false,
            deleteRecordDialogText: this.$t("delete_record_dialog_text"),
            deleteAllRecordDialog: false,
            deleteAllRecordDialogText: this.$t("delete_all_record_dialog_text"),
            deleteLoading: false,
            indexRecordingsDialog: false,
            recordsStatistics:{max_recording_time:0,recording_total_time:0,recording_remaining_time:0,recording_count:0},
            showFilter: false,
            nameFilter: '',
            meetingIdFilter: '',
            recordIdFilter: '',
            startTimeFilter: '',
            startTimeDatePicker: false,
            editedIndex: -1,
            itemPerPage: 10,
            pageNumber: 1,
            plans: [],
            loading: false,
            options: {},
            totalRows: 0,
            startRow: 0,
            endRow: 10,
            frontendUrl: '',
            recordsDialog: false,
            record: {},
        };
    },
    watch: {
        options: {
            handler() {
                this.getRecordsList();
            },
            deep: true,
        }
    },
    methods: {
        getRecordsList() {
            const { page, itemsPerPage } = this.options;
            const payload = { page: page, itemsPerPage: itemsPerPage };
            if (this.nameFilter != '')      payload['name'] = this.nameFilter;
            if (this.recordIdFilter != '')      payload['recordId'] = this.recordIdFilter;
            if (this.meetingIdFilter != '')      payload['meetingId'] = this.meetingIdFilter;
            if (this.startTimeFilter != "") payload["startTime"] = (this.startTimeFilter || "").toString().split(",");
            this.loading = true;
            if (this.data.company_id) {
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.data.company_id + "/records",
                    method: "GET",
                    headers: {
                        // 'Content-Type': 'multipart/form-data',
                        Authorization: this.$store.get("login/token"),
                    },
                    params: payload
                }).then(response => {
                    const data = response.data;
                    this.recordsList = data.data;
                    this.totalRows = data.totalRows;
                    this.loading = false;
                });
            }
        }, 
        getRecordsStatistics() {
            if (this.data.company_id) {
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.data.company_id + "/records_statistics",
                    method: "GET",
                    headers: {
                        // 'Content-Type': 'multipart/form-data',
                        Authorization: this.$store.get("login/token"),
                    },
                }).then(response => {
                    console.log(response)
                    this.recordsStatistics = response.data;
                    console.log("aaaaaaaaaaa",this.recordsStatistics)
                });
            }
        }, 
        deleteRecord() {
            this.deleteLoading = true;
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.data.company_id + "/records/delete",
                method: "POST",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
                data: { 'recordIds': this.selectedRecords.map((record)=>{return record.id}) }
                
            })
                .then((response) => {
                    this.deleteRecordDialog=false;
                    this.getRecordsList();
                    this.$toasted.success(this.$t("record_deleted_successfully"));
                })
                .catch((error) => {
                    console.log(error.response);
                    this.$toasted.error(this.$t("record_error_deleting"));
                })
                .finally(() => {
                    this.deleteLoading = false;
                });
        },
        deleteAllRecord() {
            this.deleteLoading = true;
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.data.company_id + "/records/deleteall",
                method: "DELETE",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
            })
                .then((response) => {
                    this.deleteAllRecordDialog=false;
                    this.getRecordsList();
                    this.$toasted.success(this.$t("record_deleted_successfully"));
                })
                .catch((error) => {
                    console.log(error.response);
                    this.$toasted.error(this.$t("record_error_deleting"));
                })
                .finally(() => {
                    this.deleteLoading = false;
                });
        },
        getLink(record, type = "presentation") {
            if (record == null) return;
            if (record?.formats == undefined) return record.playbackUrl;
            const jsonFormat = JSON.parse(record.formats);
            return jsonFormat.filter(item => item.type === type)[0]?.url

        },
        joinTo(code) {
            window.open(this.frontendUrl + "/join/" + code, "_blank");
        },
        validateWebinarSessionForm() {
            this.$refs.webinarSessionForm.validate();
        },
        resetValidateWebinarSessionForm() {
            // this.$refs.webinarForm.resetValidation();
        },
        close() {
            this.sessionDialog = false;
            this.$nextTick(() => {
                this.editedSessionItem = Object.assign({}, this.defaultSessionItem);
                this.editedIndex = -1;
                this.resetValidateWebinarSessionForm();
            });
        },
        indexRecordings() {
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.data.company_id + "/index_recordings",
                method: "POST",
                headers: {
                    Authorization: this.$store.get("login/token"),
                },
            }).then(response => {
                this.$toasted.success(this.$t("index_recordings_successfully"));
            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("index_recordings_error"));
            }).finally(() => {
                this.indexRecordingsDialog = false;
            });
        }
    },
    mounted() {
        this.getRecordsList();
    },
    beforeMount() {
        this.getRecordsStatistics();
    }
}
</script>